import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/lib/Collapse';
import ItemWrapper from './ItemWrapper';
import Title from './Title';
import CheckboxWithOnly from './CheckboxWithOnly';
import {formatPrice} from 'lib/helpers/globalize-helper';

class Airlines extends Component {
  state = {
    show: true
  };

  toggleFilter = () => this.setState((prevState) => ({show: !prevState.show}));

  toggleAirline = (e) => this.props.toggleAirline(e.target.value);

  render() {
    const {show} = this.state;
    const {
      allAirlinesAreChecked, airlines, selectSingleAirline,
      toggleAirlinesWithCombinations, toggleAllAirlines, currency, translations
    } = this.props;
    const {airlines: airlinesTr, allAirlines, airlineCombination} = translations;

    return (
      <ItemWrapper>
        <Title
          title={airlinesTr}
          isOpen={show}
          onClick={this.toggleFilter}
        />
        <Collapse in={show}>
          <div className="filter-content">

            <CheckboxWithOnly
              key={allAirlines}
              value={allAirlines}
              isChecked={allAirlinesAreChecked}
              label={allAirlines}
              onChange={() => toggleAllAirlines()}
            />

            {
              airlines.options.map(({name, price, code}) => (
                <CheckboxWithOnly
                  key={code}
                  value={code}
                  isChecked={airlines.selectedOptions.indexOf(code) !== -1}
                  label={name || code}
                  price={formatPrice(price, currency)}
                  onChange={this.toggleAirline}
                  onClickOnly={selectSingleAirline}
                  translations={translations}
                />))
            }

            <CheckboxWithOnly
              key={airlineCombination}
              value={airlineCombination}
              isChecked={airlines.withCombinations === null ? true : airlines.withCombinations}
              label={airlineCombination}
              onChange={() => toggleAirlinesWithCombinations()}
            />

          </div>
        </Collapse>
      </ItemWrapper>
    );
  }
}

Airlines.propTypes = {
  airlines: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.number,
    code: PropTypes.string,
    options: PropTypes.object.isRequired,
    selectedOptions: PropTypes.object.isRequired,
    withCombinations: PropTypes.bool
  }),
  allAirlinesAreChecked: PropTypes.bool.isRequired,
  selectSingleAirline: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  toggleAllAirlines: PropTypes.func.isRequired,
  toggleAirline: PropTypes.func.isRequired,
  toggleAirlinesWithCombinations: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    airlines: PropTypes.string.isRequired,
    allAirlines: PropTypes.string.isRequired,
    airlineCombination: PropTypes.string.isRequired,
    priceRange: PropTypes.string.isRequired,
    maxPrice: PropTypes.string.isRequired,
    reset: PropTypes.string.isRequired
  })
};

export default Airlines;
